import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import img from '../Assets/Group 1000005966.png'
import img2 from '../Assets/mission1.png'
import img3 from '../Assets/mission2.png'
import icon7 from '../Assets/image 18.png'
import icon8 from '../Assets/image 19.png'
import icon9 from '../Assets/image 20.png'
import Footer from '../Components/Footer'
import i1 from '../Assets/s01.png'
import i2 from '../Assets/s02.png'
import i3 from '../Assets/s03.png'
import i4 from '../Assets/s04.png'
import i5 from '../Assets/s05.png'
import i6 from '../Assets/s06.png'
import i7 from '../Assets/s07.png'
import i8 from '../Assets/s08.png'
import i9 from '../Assets/s09.png'
import i10 from '../Assets/s010.png'
import i11 from '../Assets/s011.png'
import i12 from '../Assets/s012.png'
import i13 from '../Assets/s013.png'
import i14 from '../Assets/s014.png'
import i15 from '../Assets/s015.png'
import i16 from '../Assets/s016.png'
import Affiliations1 from '../Assets/logo1.jpg'
import Affiliations2 from '../Assets/logo2.png'
import Affiliations3 from '../Assets/logo3.png'
import Affiliations4 from '../Assets/logo4.png'
import Affiliations5 from '../Assets/logo5.jpeg'
import img1 from '../Assets/1.png'
import imge2 from '../Assets/2.png'
import imge3 from '../Assets/3.png'
import imge4 from '../Assets/4.jpeg'
import imge5 from '../Assets/5.jpeg'
import img6 from '../Assets/6.jpeg'
import img7 from '../Assets/7.jpeg'
import { Create_Api, Get_Api } from '../Api_Url'
import { toast } from 'react-toastify'
import GetSeodata from '../Components/GetSeodata'

function About() {

  const [AllDestination, setAllDestination] = useState([]);
  const [IsUploading, setIsUploading] = useState(false);

  const GetAllDestination = async () => {
    try {
      setIsUploading(true)
      const response = await Get_Api(`api/admin/GetAllDestination`)
      setAllDestination(response?.data)
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    GetAllDestination();
  }, []);

  const [selectedDestination, setSelectedDestination] = useState("");

  const handleChange = (e) => {
    setSelectedDestination(e.target.value);
  };



  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');

  const SendContactUs = async (e) => {
    e.preventDefault();
    if (!Name) return toast.error('Name is required!');
    if (!Email) return toast.error('Email is required!');
    if (!Number) return toast.error('Number is required!');
    try {
      let data = {
        Name,
        Email,
        Number,
        Destination: selectedDestination
      }
      setIsUploading(true)
      const response = await Create_Api(`api/admin/CreateDestinationForm`, data)
      toast.success(response?.message);
      setName('')
      setEmail('')
      setNumber('')
      setSelectedDestination('')
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }

  return (
    <>
      <Navbar />
      <GetSeodata PageName={'about'} />
      <div className='about-div'>
        <h1>ABOUT US</h1>
        <p><i>Home - About Us</i></p>

      </div>
      <div className='ABOUT-div-l'>
        <div className='ABOUT-div-left'>
          <img src={img} />

        </div>
        <div className='ABOUT-div-right'>
          <p>Explera Vacations Co., Ltd. is a premier B2B Destination Management Company (DMC) based in Phuket, Thailand, dedicated to delivering exceptional travel experiences for global clients. Established in June 2022, and backed by 13+ years of expertise in the travel and tourism industry, we are officially accredited by the Tourism Authority of Thailand (TAT). This recognition assures the highest standards of professionalism, service quality, and trustworthiness in the competitive travel market.
            As a leading DMC, we specialize in crafting unique and seamless travel experiences across Thailand and beyond. From pristine tropical beaches to cultural landmarks and vibrant cityscapes, Explera Vacations Co., Ltd. blends local expertise with global service standards to design unforgettable journeys. Serving travelers from regions such as Russia, the Middle East, Asia, and Europe, we pride ourselves on delivering tailored travel solutions that cater to every client’s unique needs.
            Our expertise extends beyond leisure travel. Whether it’s M.I.C.E. (Meetings, Incentives, Conferences, and Exhibitions), luxury travel, or adventure-packed holidays, we ensure precision, professionalism, and excellence in every aspect of our services.
          </p>

        </div>
      </div>
      <div className='mission'>
        <h2>OUR MISSION & VISION</h2>
        <br />
        <br />
        <div className='mission-div'>
          <div className='mission-div-left'>
            <h3>Mission</h3>
            <br />
            <p>At Explera Vacations Co., Ltd., our mission is to create transformative travel experiences through personalized service, cultural discovery, and sustainable tourism. We design unique itineraries, ensure seamless journeys, and leverage innovation to exceed expectations. Committed to preserving heritage and fostering global connections, we craft life-changing journeys that inspire and enrich travelers.</p>

          </div>
          <div className='mission-div-right'>
            <img src={img2} />
          </div>
        </div>
        <br />
        <br />
        <div className='mission-div'>
          <div className='mission-div-right'>
            <img src={img3} />
          </div>
          <div className='mission-div-left'>
            <h3>Vision</h3>
            <br />
            <p>At Explera Vacations Co., Ltd., our vision is to become a globally recognized leader in the travel industry, celebrated for personalized service, sustainability, and innovation. We aim to redefine travel by offering transformative journeys that inspire, connect, and enrich. By blending luxury, adventure, and cultural authenticity, promoting responsible tourism, and driving industry innovation, we aspire to be the preferred travel partner for clients worldwide. At Explera, we envision travel as an experience that transforms perspectives, preserves heritage, and inspires endless possibilities.</p>

          </div>
        </div>
      </div>
      <div className='OURHISTORY'>
        <h1>OUR HISTORY</h1>
        <br />
        <br />
        <div className='OURHISTORY-div'>
          <div className='OURHISTORY-left'>
            <h3><i>2022</i></h3>
            <br />
            <h4>The Spark of Inspiration</h4>
            <br />

            <p>Founded in June 2022 in Phuket, Thailand, Explera Vacations Co., Ltd. quickly became a trusted B2B DMC, backed by 13+ years of industry expertise and accredited by the Tourism Authority of Thailand (TAT). Specializing in personalized travel, M.I.C.E., and luxury experiences, we serve clients globally and are now expanding to destinations like Indonesia, Vietnam, Europe, and Japan, with a commitment to excellence and sustainability.</p>

          </div>
          <div className='OURHISTORY-right'>

          </div>
        </div>

      </div>
      {/* <div className='OURTEAM'>
        <h1>OUR TEAM</h1>
        <br/>
        <br/>
        <div className='teams'>
        <div className='team'>

</div>
  <div className='team'>

</div>
  <div className='team'>

</div>
  <div className='team'>

</div>
        </div>

        </div> */}
      <div className='Accreditations'>
        <h3>Associate Hotel Partners</h3>
        <h4>Grab the special B2B deals on Hotels, Resorts, Villas & Apartments all over <br /> Thailand.</h4>
        <div class="marquee2">
          <div class="marquee-content">
            <img src={i1} />
            <img src={i2} />
            <img src={i3} />
            <img src={i4} />
            <img src={i5} />
            <img src={i6} />
            <img src={i7} />
            <img src={i8} />
            <img src={i9} />
            <img src={i10} />
            <img src={i11} />
            <img src={i12} />
            <img src={i13} />
            <img src={i14} />
            <img src={i15} />
            <img src={i16} />
            <img src={i1} />
            <img src={i2} />
            <img src={i3} />
            <img src={i4} />
            <img src={i5} />
            <img src={i6} />
            <img src={i7} />
            <img src={i8} />
            <img src={i9} />
            <img src={i10} />
            <img src={i11} />
            <img src={i12} />
            <img src={i13} />
            <img src={i14} />
            <img src={i15} />
            <img src={i16} />
            <img src={i1} />
            <img src={i2} />
            <img src={i3} />
            <img src={i4} />
            <img src={i5} />
            <img src={i6} />
            <img src={i7} />
            <img src={i8} />
            <img src={i9} />
            <img src={i10} />
            <img src={i11} />
            <img src={i12} />
            <img src={i13} />
            <img src={i14} />
            <img src={i15} />
            <img src={i16} />
          </div>
        </div>
      </div>
      <div className='Accreditations'>
        <h3>Associate Activity & <br /> Entertainment Partners</h3>
        <h4>Grab the special B2B deals on Attractions & Activities all over Thailand.</h4>
        <div class="marquee2">
          <div class="marquee-content1">
            <img src={img1} />
            <img src={imge2} />
            <img src={imge3} />
            <img src={imge4} />
            <img src={imge5} />
            <img src={img6} />
            <img src={img7} />
            <img src={img1} />
            <img src={imge2} />
            <img src={imge3} />
            <img src={imge4} />
            <img src={imge5} />
            <img src={img6} />
            <img src={img7} />
          </div>
        </div>
      </div>



      <div className='Accreditations'>
        <h3>Our Affiliations</h3>
        <br />
        <div className='Affiliations-img'>
          <img src={Affiliations1} />
          <img src={Affiliations2} />
          <img src={Affiliations3} />
          <img src={Affiliations4} />
          <img src={Affiliations5} />
        </div>

      </div>
      <div className='ready-to'>
        <div className='ready-to-div'>
          <h3><i>Ready to embark</i> on
            your next adventure?</h3>
          <br />
          <label>Name</label>
          <input
            placeholder='Your Name'
            value={Name}
            onChange={(e) => { setName(e.target.value) }}
          />
          <br />
          <br />
          <label>Email Address</label>
          <input
            placeholder='Your Email'
            value={Email}
            onChange={(e) => { setEmail(e.target.value) }}
          />
          <br />
          <br />
          <label>Number</label>
          <input
            placeholder='Your Number'
            value={Number}
            onChange={(e) => { setNumber(e.target.value) }}
          />
          <br />
          <br />
          <div>
            <label>Destination</label>
            <select value={selectedDestination} onChange={handleChange}>
              <option value="" disabled>Select one...</option>
              {AllDestination.map((dest) => (
                <option key={dest._id} value={dest._id}>
                  {dest.DestinationName}
                </option>
              ))}
            </select>
          </div>
          <br />
          <br />
          <button onClick={(e) => { SendContactUs(e) }}>{IsUploading ? "Please Wait" : 'Submit'}</button>
        </div>
      </div>
      <Footer />

    </>
  )
}

export default About